import React, { useEffect, useState } from "react";
import "./Slider.css";
import {
  New_ScrollX2025,
  SX_renderpage_tick,
  Tick_BoxesPLan,
} from "../../assets/icons";

const SliderRectCard = ({
  handleChange,
  planId,
  plantype,
  planText,
  moneyBackText,
  currency,
  PlanPrice,
  PlanInterval,
  renderLimit,
  renderType,
  daysLimit,
  formateType,
  cancelCondition,
  currentPlan,
  onClick,
  subscription_status,
  currentPlanId,
  isExpired,
  type, 
  teams,
  tag
}) => {
  const [isActiveSelected, setisActiveSelected] = useState("");
  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const isEmptyObject =
    currentPlan &&
    Object.keys(currentPlan).length === 0 &&
    currentPlan.constructor === Object;

  useEffect(() => {
    if (currentPlanId === planId && !isExpired) {
      setisActiveSelected(true);
    } else if (currentPlanId !== planId) {
      setisActiveSelected(false);
    }
  }, []);

  return (
    <>
      <div
        className={`w-full h-full bg-[#191920] UpgradePlanBG  border-[2px] ${currentPlanId === planId ? "border-[#413CAA]" : "border-[#3A3A3A]"} rounded-[30px] p-[1.8rem] `}
      >
        <div className="w-full h-full ">
          <div
            className=""
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
              height: "100%",
              textAlign: "center",
              borderRadius: "10px",
              padding: "0px 0px",
              position: "relative",
            }}
          >
            {/* <div>
            {(currentPlanId === planId && !isExpired) || (subscription_status === 2 && PlanPrice === 0) ? (
              <img className="w-[40px] grayscale" src={New_ScrollX2025} alt="" />
            ) : (
              <img className="w-[40px] " src={New_ScrollX2025} alt="" />
            )}
          </div> */}

            {/* <h1 className="manrope-600 text-[22px] text-white py-3 uppercase">{plantype === "FREE" ? "Free" : plantype}</h1> */}
            <div className="w-[5%] flex items-center pt-1.5 ">
              <input
                type="radio"
                name="plan"
                checked={isActiveSelected}
                onChange={handleChange}
              />
            </div>

            <div className="w-full">
              <div className="w-full flex justify-between ">
                <div className="flex flex-col gap-1.5 ">
                  <div className="flex">
                    <h1 className="manrope-600 text-[22px] text-white  uppercase">
                      {plantype === "FREE" ? "Free" : plantype}
                    </h1>
                  </div>

                  <div className="">
                    <p className="manrope-400 text-[13px] text-left text-white leading-[1.2] ">
                      {teams}
                    </p>
                  </div>
                </div>
                <div>
                  <p
                    className={` border-[1px] rounded-2xl px-2 py-1 manrope-600 text-[14px]    leading-[1.2]  ${currentPlanId === planId ? "border-[#4b3fcb] bg-[#4b3fcb4d] text-[#4b3fcb]" : " text-[#ffc738] bg-[#ffc73843] border-[#ffc73a]"}`}
                  >
                    {tag}
                  </p>
                </div>
              </div>
              <div className="w-full text-left py-[10px]">
                <h1 className="text-[24px] text-white manrope-600 ">
                  {currency + PlanPrice}
                  <span className="text-[15px]  text-[#ffffffcc] capitalize">
                    {" "}
                    {"/ " + PlanInterval}
                  </span>
                </h1>
              </div>

              {/* <div className=" my-3" style={{ borderBottom: "1px solid #282831", width: "100%" }} /> */}

              <div className="w-full min-h-fit  ">
                {/* <h1 className="text-white  text-[20px] manrope-400 border-b-[1px] text-start  border-[#282831]"> Plan includes: </h1> */}

                <div className="flex flex-col justify-center text-white pb-2 text-[15px]  manrope-400 ">
                  <div className="pb-[4px] flex items-center">
                    {/* <img className="w-[16px] h-full  mr-3" src={Tick_BoxesPLan} alt="" /> */}
                    <h3 className="text-green-700 w-[16px] h-full mr-3">✔</h3>
                    <h3 className="text-left">{renderLimit}</h3>
                  </div>

                  <div className="py-[4px]  flex items-center">
                    <h3 className="text-green-700 w-[16px] h-full mr-3">✔</h3>
                    {/* <img className="w-[16px] h-full  mr-3" src={Tick_BoxesPLan} alt="" /> */}
                    <h3 className="text-left">{renderType}</h3>
                  </div>

                  {/* <div className="py-[4px] flex  items-center"><img className="w-[16px] h-full  mr-3" src={Tick_BoxesPLan} alt=""/><h3 className="text-left">{daysLimit}</h3></div> */}

                  <div className="py-[4px] flex  items-center">
                    <h3 className="text-green-700 w-[16px] h-full mr-3">✔</h3>
                    {/* <img className="w-[16px] h-full  mr-3" src={Tick_BoxesPLan} alt=""/> */}
                    <h3 className="text-left">{formateType}</h3>
                  </div>

                  <div className="py-[4px] flex  items-center">
                    <h3 className="text-green-700 w-[16px] h-full mr-3">✔</h3>
                    {/* <img className="w-[16px] h-full  mr-3" src={Tick_BoxesPLan} alt="" /> */}
                    <h3 className="text-left">{cancelCondition}</h3>
                  </div>

                  <div className="py-[4px] flex  items-center">
                    <h3 className="text-green-700 w-[16px] h-full mr-3">✔</h3>
                    {/* <img className="w-[16px] h-full  mr-3 " src={moneyBackText ? Tick_BoxesPLan : "#"} alt="" /> */}
                    <h3 className="text-left">
                      {moneyBackText ? moneyBackText : ""}
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="w-full mt-3">
            {(currentPlanId === planId && !isExpired) || (subscription_status === 2 && PlanPrice === 0) ? (
              <span className="flex items-center justify-center w-full CurrnetPLanBG py-[8px] text-white manrope-600 rounded-[10px] text-center border-[1px] border-[#616161]">
                <img className="w-4 h-full mr-2" src={SX_renderpage_tick} alt="" />
                {currentPlanId === planId && subscription_status === 1 ? "Current Plan" : "Current"}
              </span>
            ) : (
              <button className="w-full PlanUpgradeBG py-[8px] text-white manrope-600 rounded-[10px]"
                //   onClick={(subscription_status === 2 && PlanPrice !== 0) || (subscription_status === undefined && PlanPrice !== 0) ? 'onClick' : null}
              >
                {PlanPrice === 0 ? "Free" : "Upgrade"}
              </button>
            )}
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SliderRectCard;
